/** How care is delivered, independent of the scheduling channel (Voice, SMS or Web). */
export enum CareMode {
  IN_PERSON = "in_person",
  TELEHEALTH = "telehealth",
}
